import styled from 'styled-components';
import {
  brand,
  breakpoints,
  ink,
  surface,
  tones,
  touchTarget,
} from '../../../styles/brand';

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;

  @media (max-width: ${breakpoints.md}) {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.5rem;

    /* Ação extra (ex.: banca do nacional): linha inteira, não um bloco sozinho. */
    > :nth-child(n + 5) {
      grid-column: 1 / -1;
      flex-direction: row;
      min-height: ${touchTarget};
      font-size: 0.85rem;
    }
  }
`;

export const Tile = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: ${touchTarget};
  padding: 0 1.1rem;
  border-radius: 0.65rem;
  border: 1.5px solid ${surface.line};
  background: ${brand.white};
  color: ${ink};
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.9rem;
  cursor: pointer;
  touch-action: manipulation;
  transition:
    transform 100ms ease-out,
    border-color 160ms ease,
    color 160ms ease;

  svg {
    width: 1.15rem;
    height: 1.15rem;
    flex: none;
    color: ${brand.blue};
    transition: color 160ms ease;
  }

  @media (hover: hover) {
    &:hover {
      border-color: ${brand.green};
      color: ${tones.green.text};

      svg {
        color: ${brand.green};
      }
    }
  }

  &:active {
    transform: scale(0.97);
  }

  &:focus-visible {
    outline: 2px solid ${brand.blue};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${brand.gray};

    svg {
      color: ${brand.gray};
    }
  }

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    justify-content: center;
    gap: 0.35rem;
    min-height: 4.25rem;
    padding: 0.5rem 0.25rem;
    border-width: 1px;
    border-radius: 0.9rem;
    font-size: 0.75rem;
    text-align: center;

    svg {
      width: 1.4rem;
      height: 1.4rem;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    &:active {
      transform: none;
    }
  }
`;
